<!-- Notifications toggle -->
<button
    mat-icon-button
    (click)="openPanel()"
    #notificationsOrigin>
    <ng-container *ngIf="unreadCount > 0">
        <span class="absolute top-0 right-0 left-0 flex items-center justify-center h-3">
            <span
                class="flex items-center justify-center shrink-0 min-w-4 h-4 px-1 ml-4 mt-2.5 rounded-full bg-primary-600 text-indigo-50 text-xs font-medium">
                {{unreadCount || 0}}
            </span>
        </span>
    </ng-container>
    <mat-icon [svgIcon]="'heroicons_outline:bell'"></mat-icon>
</button>

<!-- Notifications panel -->
<ng-template #notificationsPanel>
    <ng-container *transloco="let t">
        <div
            class="fixed inset-0 sm:static sm:inset-auto flex flex-col sm:min-w-90 sm:w-90 sm:rounded-2xl overflow-hidden shadow-lg">

            <!-- Header -->
            <div class="flex shrink-0 items-center py-4 pr-4 pl-6 bg-primary text-on-primary">
                <div class="sm:hidden -ml-1 mr-3">
                    <button
                        mat-icon-button
                        (click)="closePanel()">
                        <mat-icon
                            class="icon-size-5 text-current"
                            [svgIcon]="'heroicons_solid:x'"></mat-icon>
                    </button>
                </div>
                <div class="text-lg font-medium leading-10" style="color: white">{{t('common.notifiche')}}</div>
                <div class="ml-auto">
                    <button
                        mat-mini-fab
                        [disabled]="!(unreadCount  > 0)"
                        color="accent"
                        [matTooltip]="t('common.segna_tutte_come_letto')"
                        (click)="markAllAsRead()">
                        <ng-container *ngIf="loadingAll; else noLoading">
                            <mat-icon>
                                <mat-spinner [diameter]="15"></mat-spinner>
                            </mat-icon>
                        </ng-container>
                        <ng-template #noLoading>
                            <mat-icon
                                class="icon-size-5 text-current"
                            >done_all</mat-icon>
                        </ng-template>

                    </button>
                </div>
            </div>

            <!-- Content -->
            <div class="relative flex flex-col flex-auto sm:max-h-120 divide-y overflow-y-auto bg-card"
                 (scroll)="onTableScroll($event)">
                <!-- Notifications -->
                <ng-container *ngFor="let notifica of notifiche; trackBy: trackByFn">
                    <div
                        class="flex group hover:bg-gray-50 dark:hover:bg-black dark:hover:bg-opacity-5"
                        [ngClass]="{'unread': !notifica.isLetto}">


                        <div
                            (click)="goTo(notifica)"
                            class="flex flex-auto py-5 pl-6 cursor-pointer">
                            <ng-container *ngTemplateOutlet="notificationContent"></ng-container>
                        </div>


                        <!-- Actions -->
                        <div class="relative flex flex-col my-5 mr-6 ml-2">
                            <!-- Indicator -->
                            <button
                                *ngIf="!notifica.isLetto"
                                class="w-6 h-6 min-h-6"
                                mat-icon-button
                                [disabled]="loadingAll"
                                (click)="toggleRead(notifica)"
                                [matTooltip]="t('common.segna_come_letto')">
                                <ng-container *ngIf="notifica.loading; else noLoading">
                                    <mat-icon>
                                        <mat-spinner [diameter]="15"></mat-spinner>
                                    </mat-icon>
                                </ng-container>
                                <ng-template #noLoading>
                                                      <span
                                                          class="w-2 h-2 rounded-full"
                                                          [ngClass]="{'bg-gray-400 dark:bg-gray-500 sm:opacity-0 sm:group-hover:opacity-100': notifica.isLetto,
                                            'bg-primary': !notifica.isLetto}"></span>
                                </ng-template>

                            </button>
                        </div>

                    </div>

                    <!-- Notification content template -->
                    <ng-template #notificationContent>

                        <!-- Title, description & time -->
                        <div class="flex flex-col flex-auto">
                            <ng-container *ngIf="notifica.tipo">
                                <div
                                    class="font-semibold line-clamp-1">{{notifica.tipo | removeUnderscores | titlecase}}</div>
                            </ng-container>
                            <ng-container *ngIf="notifica.descrizione">
                                <div
                                    [innerHTML]="notifica.descrizione | safeHtml"></div>
                            </ng-container>
                            <div class="mt-2 text-sm leading-none text-secondary">
                                {{notifica.createdAt | dateToUtcPipe | dataFormat}}
                            </div>
                        </div>
                    </ng-template>
                </ng-container>

                <div class="flex flex-col flex-auto items-center justify-center"
                     style="padding-bottom: 30px; padding-top: 30px" *ngIf="loadingData">
                    <mat-spinner color="primary" diameter="50"></mat-spinner>
                </div>
                <!-- No notifications -->
                <ng-container *ngIf="!loadingData && (!notifiche || !notifiche.length)">
                    <div class="flex flex-col flex-auto items-center justify-center sm:justify-start py-12 px-8">
                        <div class="flex flex-0 items-center justify-center w-14 h-14 rounded-full bg-primary-100">
                            <mat-icon
                                class="text-primary-500-700"
                                [svgIcon]="'heroicons_outline:bell'"></mat-icon>
                        </div>
                        <div class="mt-5 text-2xl font-semibold tracking-tight">{{t('common.no_notifiche')}}</div>
                        <div
                            class="w-full max-w-60 mt-1 text-md text-center text-secondary">{{t('common.no_notifiche_text')}}</div>
                    </div>
                </ng-container>

            </div>

        </div>

    </ng-container>

</ng-template>
